// extracted by mini-css-extract-plugin
export var iconStyle = "search_jobs_result_link-module--iconStyle--6z+gs";
export var isActiveStyle = "search_jobs_result_link-module--isActiveStyle--d-WiE";
export var jobLinkInnerStyle = "search_jobs_result_link-module--jobLinkInnerStyle--6BWep";
export var jobLinkOuterStyle = "search_jobs_result_link-module--jobLinkOuterStyle--q0mpw";
export var jobTitleStyle = "search_jobs_result_link-module--jobTitleStyle--7sR6U";
export var teamStyle = "search_jobs_result_link-module--teamStyle--iQad6";